import React from "react";
import { Link } from "react-router-dom";
import CookieConsent from "react-cookie-consent";
import { useI18n } from "./utils/i18n";

// The necessary-cookies notice. It sits at the bottom so it never covers the
// nav's sign-in buttons, and below the auth modal (z-50). It is a brand-level
// surface, so it uses the brand pastel button, never a module colour; its bar
// follows the day/night scene (--brand-bar, src/scene/brandSurfaces.css).
// The cookie name is unchanged so earlier dismissals still count.
export default function CookieNotice() {
  const { t } = useI18n();
  const [beforeLink, afterLink = ""] = t("cookie.notice").split("{privacy}");

  return (
    <CookieConsent
      location="bottom"
      cookieName="userCookieConsent"
      expires={365}
      disableStyles
      buttonText={t("cookie.accept")}
      ariaAcceptLabel={t("cookie.accept")}
      containerClasses="fixed inset-x-0 bottom-0 z-40 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 border-t border-[rgba(226,232,240,0.14)] bg-[var(--brand-bar)] px-4 py-3 text-[0.85rem] leading-[1.5] text-slate-300"
      contentClasses="max-w-[44rem]"
      buttonClasses="cursor-pointer rounded-pill border border-[rgba(255,255,255,0.32)] bg-[linear-gradient(110deg,#8fd3ff_0%,#d9f99d_48%,#fed7aa_100%)] px-4 py-1.5 text-[0.85rem] font-extrabold text-[#075985]"
    >
      {beforeLink}
      <Link to="/privacy" className="font-bold text-sky-400 no-underline">
        {t("legal.privacy")}
      </Link>
      {afterLink}
    </CookieConsent>
  );
}
